import { gql } from '@apollo/client';
import { IDENTIFIER_FRAGMENT } from '../../shared/fragments';

export const FETCH_ALL_APPOINTMENTS_QUERY = gql`
  query fetchAllAppointments {
    fetchAllAppointments {
      id
      status
      start
      end
      created
      participant {
        period {
          start
          end
        }
        individual {
          reference
          display
          identifier {
            system
            value
            use
          }
        }
        actor {
          reference
        }
      }
      serviceType {
        text
        system
        code
      }
      identifier {
        ...identifier
      }
      extension {
        url
        valueString
        valueReference {
          type
          display
          reference
        }
      }
    }
  }
  ${IDENTIFIER_FRAGMENT}
`;

export const FETCH_APPOINTMENT_BY_ID = gql`
  query fetchAppointmentsById($apptId: String) {
    fetchAppointmentsById(apptId: $apptId) {
      appointmentResource
      docArn
    }
  }
`;
export const SCHEDULE_APPOINTMENT_QUERY = gql`
  mutation createAppointment($scheduleAppointments: ScheduleAppointments) {
    createAppointment(scheduleAppointments: $scheduleAppointments) {
      appointmentResource
      docArn
    }
  }
`;
